import ModalBasicLayout from "./ModalBasicLayout";
import StripePayForm from "../Billing/StripePayForm";
import useShowVerifySubscriptionModal from "../../hooks/useShowVerifySubscriptionModal";
import { useDispatchApp } from "../../lib/redux";
import { useTranslationApp } from "../../lib/i18next";
import { startVerifySubscriptionCustomer } from "../../actions/payments";
import {
  VERIFY_SUBSCRIPTION_CTA,
  VERIFY_SUBSCRIPTION_DESCRIPTION,
  VERIFY_SUBSCRIPTION_TITLE,
} from "../../i18n/keysTranslations";

const preventClose = () => false;

const ModalVerifySubscription = () => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const { showVerifySubscriptionModal } = useShowVerifySubscriptionModal();

  const onSubmit = async ({ id }) => {
    const response = await dispatch(
      startVerifySubscriptionCustomer({ paymentMethodID: id })
    );
    if (!response?.ok) {
      throw new Error(response?.message || t(VERIFY_SUBSCRIPTION_TITLE));
    }
    return { ok: true };
  };

  if (!showVerifySubscriptionModal) {
    return null;
  }

  return (
    <ModalBasicLayout
      modalOpen={true}
      onCloseModal={preventClose}
      showCloseButton={false}
      enableHistoryManagement={false}
      hasTitle={false}
      fullWidth
      scroll="paper"
      ariaLabel={t(VERIFY_SUBSCRIPTION_TITLE)}
      title={t(VERIFY_SUBSCRIPTION_TITLE)}
      description={t(VERIFY_SUBSCRIPTION_DESCRIPTION)}
      sxDescription={{ color: "text.secondary", mt: 1 }}
    >
      <StripePayForm
        textButton={VERIFY_SUBSCRIPTION_CTA}
        saveCard={false}
        onSubmit={onSubmit}
      />
    </ModalBasicLayout>
  );
};

export default ModalVerifySubscription;
